module.exports = __webpack_public_path__ + "img/brand-cases21.0f499b96.png";